import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAnalyticsConnector } from '@obvious.tech/constellation'

export const AnalyticsConnector = defineEntity('AnalyticsConnector', {
  endpoint: 'analytics/api/AnalyticsConnector',
  schema: SNoop<IAnalyticsConnector>(),
})
